<template>
  <div>
    <el-upload
      drag
      ref="uploadChallengeVideo"
      :action="`${url}talent-scout/track/video`"
      :headers="headers"
      accept=".mp4"
      :on-success="onSuccess"
      :on-error="onError"
      :on-exceed="onExceed"
      :on-progress="onProgress"
      :on-remove="onRemove"
      :limit="1"
      name="video"
    >
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">
        Drop file here or <em>click to upload</em>
      </div>
      <div class="el-upload__tip" slot="tip">*only mp4 files allowed</div>
    </el-upload>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper'
import Wrapper from '@/global/components/Wrapper'
import Results from '@/global/components/Result'
import 'vue-advanced-cropper/dist/style.css'
import { mapState, mapActions, mapMutations } from 'vuex'

export default {
  props: ['track_id', 'image_url'],
  components: {
    Results,
    Cropper,
    Wrapper
  },
  data() {
    return {
      url: process.env.VUE_APP_STORAGE_URL,
      img: null,
      coordinates: {
        width: 0,
        height: 0,
        left: 0,
        top: 0
      },
      imageUpload: {
        id: null,
        image: null
      },
      canvas: null,
      isError: false,
      resultImage: null
    }
  },
  computed: {
    ...mapState('newReleasesTracks', ['track_image'])
  },
  methods: {
    ...mapActions('newReleasesTracks', ['uploadImage']),
    ...mapMutations('newReleasesTracks', ['setTrackImage']),
    onChange({ coordinates, canvas }) {
      this.coordinates = coordinates
      this.canvas = canvas
      this.resultImage = canvas.toDataURL()
    },
    loadImage(event) {
      // Reference to the DOM input element
      var input = event.target
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader()
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.resizeImageBase64(e.target.result)
          event.target.value = ''
          this.setTrackImage(null)
        }
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0])
      }
    },
    upload() {
      if (this.canvas) {
        this.imageUpload.id = this.track_id
        this.imageUpload.image = this.canvas.toDataURL('image/jpeg')
        this.img = null
        this.canvas = null
        this.resultImage = null
        this.uploadImage(this.imageUpload)
      } else {
        this.$message({
          type: 'error',
          message: `You need to load image first`
        })
      }
    },
    imageFailed() {
      this.isError = true
    }
  }
}
</script>

<style lang="scss">
.cropper {
  height: 600px;
  max-width: 600px;
}
.block {
  height: 600px;
  width: 600px;
}

.error-image {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  text-align: center;
}

.error-image-slot {
  font-size: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
}

.button input {
  display: none;
}

.button-load {
  display: inline-block;
}
</style>
